import React, { forwardRef } from "react";
import styled, { css } from "styled-components";
import { variant, system } from "styled-system";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { Box } from "atoms";

export const TextBase = styled(Box)`
  ${variant({
    variants: {
      // new variants
    },
  })}
  ${system({
    lineHeight: {
      property: "lineHeight",
      scale: "lineHeights",
    },
  })}
  ${system({
    fontWeight: {
      property: "fontWeight",
      scale: "fontWeights",
    },
  })}
  ${({ textTransform }) =>
    textTransform &&
    css`
      text-transform: ${textTransform};
    `}
  ${({ textDecoration }) =>
    textDecoration &&
    css`
      text-decoration: ${textDecoration};
    `}
	${({ wordBreak }) =>
    wordBreak &&
    css`
      word-break: ${wordBreak};
    `}
`;

export const Text = forwardRef(({ children, id, values, ...props }, textRef) =>
  id ? (
    <FormattedMessage id={id} values={values}>
      {(text) => (
        <TextBase {...props} ref={textRef}>
          {text}
        </TextBase>
      )}
    </FormattedMessage>
  ) : (
    <TextBase {...props} ref={textRef}>
      {children || null}
    </TextBase>
  )
);

Text.defaultProps = {
  fontSize: "1.6rem",
  fontFamily: "NeometricRegular",
  id: null,
};

Text.propTypes = {
  id: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
